import React from 'react'

import BaseInput from './BaseInput';

export default function TextLineInput(props) {
    return (
        <BaseInput {...props}
                   type="text"/>
    )
}